var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstabugLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 235.70999999999998 150.04",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2500,
    height: 1591,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 84.2,
    x2: 3.54,
    y1: 62.93,
    y2: 209.31
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00287a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00287a"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 193.71,
    x2: 25.51,
    xlinkHref: "#a",
    y1: 60.89,
    y2: 252.05
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 134.83,
    x2: 29.03,
    xlinkHref: "#a",
    y1: 33.61,
    y2: 224.17
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 35.85,
    x2: 118.19,
    y1: 93.83,
    y2: 93.83
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19a3ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e5fc1"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 68.23,
    x2: 172.05,
    y1: 87.57,
    y2: 77.41
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002061",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00143d"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 94.87,
    x2: -18.63,
    xlinkHref: "#a",
    y1: -35.29,
    y2: 170.7
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 121.09,
    x2: 15.29,
    xlinkHref: "#a",
    y1: -26.69,
    y2: 163.87
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 163.02,
    x2: 104.31,
    xlinkHref: "#a",
    y1: -0.95,
    y2: 124.96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.27 150.04l70.84-89.74H84.63l-70.88 89.74z",
    fill: "#64b5f9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.26 150.04l47.72-60.3H61.37l-47.72 60.3z",
    fill: "url(#a)",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.93 60.3L75.1 150h70.61a39.48 39.48 0 0 0 31-15l59-74.73z",
    fill: "#00287a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.93 60.3L75.1 150h70.61a39.48 39.48 0 0 0 31-15l59-74.73z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1 150.04l70.83-89.74h-30.84l-70.83 89.74z",
    fill: "#0098ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1 150.04l70.83-89.74h-30.84l-70.83 89.74z",
    fill: "url(#c)",
    opacity: 0.35
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.37 89.74l-6.45 8.17h61.34l6.43-8.17z",
    fill: "url(#d)",
    opacity: 0.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.35 60.3L163 74.73a39.46 39.46 0 0 1-31 15h-9.29l-6.43 8.17h16.59a45.63 45.63 0 0 0 36-17.45l15.91-20.15z",
    fill: "url(#e)",
    opacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.53 89.74L101.36 0H70.88L0 89.74z",
    fill: "#64b5f9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.53 89.74L101.36 0H70.87L.04 89.74z",
    fill: "url(#f)",
    opacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.37 89.74L132.2 0h-30.84L30.53 89.74z",
    fill: "#0098ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.37 89.74L132.2 0h-30.84L30.53 89.74z",
    fill: "url(#g)",
    opacity: 0.35
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M163 74.73L221.94 0H132.2L61.37 89.74H132a39.46 39.46 0 0 0 31-15.01z",
    fill: "#0e5fc1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M163 74.73L221.94 0H132.2L61.37 89.74H132a39.46 39.46 0 0 0 31-15.01z",
    fill: "url(#h)",
    opacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstabugLogo);
export default __webpack_public_path__ + "static/media/instabug-logo.99459b7f89a32d02a731833278934552.svg";
export { ForwardRef as ReactComponent };